import { initGallery } from './src/init-gallery';

window.Drupal.behaviors['gallery'] = {
    attach: function (context: HTMLElement | Document): void {
        context.querySelectorAll<HTMLDivElement>('[data-gallery]').forEach((el) => {
            if (el.dataset['galleryInitialized']) return;
            el.dataset['galleryInitialized'] = 'true';
            initGallery(el);
        });
    },
};
